module.exports = __webpack_public_path__ + "img/pixing_xc13.9a6f4ac7.jpg";